import React, { useMemo } from 'react';
import './CountriesBarChart.css';

const CountriesBarChart = ({
  countries = [],
  totalCount = 0,
  type = 'followers'
}) => {
  // Generate color based on type
  const getColor = () => {
    switch(type) {
      case 'followers': return '#667eea'; // Blue
      case 'reached': return '#10b981';   // Green
      case 'engaged': return '#f59e0b';   // Orange
      default: return '#667eea';
    }
  };

  const getDemographicLabel = () => {
    switch(type) {
      case 'followers': return 'seguidores';
      case 'reached': return 'alcanzados';
      case 'engaged': return 'comprometidos';
      default: return 'seguidores';
    }
  };

  // Country code to emoji flag mapping
  const getFlagEmoji = (countryCode) => {
    const code = countryCode?.toUpperCase();
    if (!code || code.length !== 2) return '🌍';

    // Convert country code to flag emoji
    const codePoints = [...code].map(c => 127397 + c.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  };

  // Sorted countries by count
  const sortedCountries = useMemo(() => {
    return [...countries]
      .sort((a, b) => b.count - a.count)
      .slice(0, 5); // Top 5
  }, [countries]);

  if (!countries || countries.length === 0) {
    return (
      <div className="countries-chart-empty">
        <p>🌍 No hay datos de países para mostrar</p>
      </div>
    );
  }

  const color = getColor();
  const maxCount = sortedCountries[0]?.count || 1;

  return (
    <div className="countries-bar-chart">

      <div className="bars-container">
        {sortedCountries.map((country, index) => {
          const percentage = totalCount > 0 ? (country.count / totalCount) * 100 : 0;
          const barWidth = maxCount > 0 ? (country.count / maxCount) * 100 : 0;

          return (
            <div key={index} className="country-bar-item-row">
              <div className="country-info-compact">
                <div className="country-rank-small">#{index + 1}</div>
                <div className="country-flag-small">{getFlagEmoji(country.country)}</div>
                <div className="country-code">{country.country}</div>
              </div>

              <div className="bar-wrapper-row">
                <div
                  className="bar-fill"
                  style={{
                    width: `${barWidth}%`,
                    backgroundColor: color,
                    opacity: 0.2 + (barWidth / 100) * 0.6
                  }}
                >
                  <div className="bar-gradient" style={{
                    background: `linear-gradient(90deg, transparent, ${color})`
                  }}></div>
                </div>
                <div className="bar-label-row">
                  <span className="percentage">{percentage.toFixed(1)}%</span>
                  <span className="count">({country.count.toLocaleString()})</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CountriesBarChart;
